"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _omniex = _interopRequireDefault(require("./omniex"));

var _six = _interopRequireDefault(require("./six"));

var layout = {
  omniex: _omniex.default,
  six: _six.default
}[process.env.REACT_APP_INSTALLATION] || _omniex.default;
var _default = layout;
exports.default = _default;